import { useContext, useState } from "react"
import getServices from "../services/getServices"
import { AuthContext } from "../contexts/auth"
import putService from "../services/putService"
import toast from "react-hot-toast"

const useTarefaState = (tipoTarefa = null) => {

    const formatDate = (date) => date.toISOString().split('T')[0];

    let lastFilter = localStorage.getItem("paloGestor@data@tarefas@filters")
    lastFilter = lastFilter ? JSON.parse(lastFilter) : null

    // Primeiro dia do mês atual
    const primeiroDia = new Date();
    primeiroDia.setDate(1);

    // Último dia do mês atual
    const ultimoDia = new Date(primeiroDia.getFullYear(), primeiroDia.getMonth() + 1, 0);

    const { signOut, user } = useContext(AuthContext)
    const [openDialog, setOpenDialog] = useState(false)

    const [templateDeletar, setTemplateDeletar] = useState(false)
    const [pesquisa, setPesquisa] = useState(lastFilter?.pesquisa || '')
    const [semSaida, setSemSaida] = useState(lastFilter?.sem_saida ||false);    
    const [dataInicial, setDataInicial] = useState(lastFilter?.data_inicial || formatDate(primeiroDia));
    const [dataFinal, setDataFinal] = useState(lastFilter?.data_final || formatDate(ultimoDia));    
    const [tarefa, setTarefa] = useState([])
    const [submit, setSubmit] = useState(false)

    //Campos para a paginação
    const [nexPage, setNextPage] = useState(null)
    const [previusPage, setPreviusPage] = useState(null)
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(0);

    const [ openPermissaoDialog, setOpenPermissaoDialog ] = useState(false)

    const _getTarefa = async (pageToFetch = 1)=>{
        if (submit){
            return;
        }
        setSubmit(true)

        let filters = {
            page: pageToFetch,
            pesquisa,
            sem_saida: semSaida,  // ou usar o estado `semSaida`
            data_inicial: dataInicial || undefined,
            data_final: dataFinal || undefined,
            tipotarefa: tipoTarefa || undefined,
        };

        localStorage.setItem('paloGestor@data@tarefas@filters',JSON.stringify(filters));
        Object.keys(filters).forEach(key => {
            if (filters[key] === null || filters[key] === '') {
            delete filters[key];
            }
        });

        let result = await getServices('admin/tarefas/', filters);
        if (result.type === 'success'){
            setTarefa(result.data.results.map(item=>{return {id:item.id, 
                                                    name: item.local_name, 
                                                    posto: item.posto,
                                                    // Tarefa sem tipo representa um Check-in na interface.
                                                    tipo : String(item.tipotarefa_nome || '').trim() || 'Check-in',
                                                    tem_formulario: item.tipotarefa?.tem_formulario, 
                                                    usuario: item?.usuario_nome, 
                                                    entrada: item?.entrada, 
                                                    saida: item?.saida,
                                                    latitude: item?.latitude,
                                                    longitude: item?.longitude,
                                                    descricao: item?.descricao,
                                                    numero_secoes : item?.numero_secoes} }))      
           setNextPage(result.data.next)
           setPreviusPage(result.data.previous)
           setTotalCount(result.data.count);                  
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        setSubmit(false)
    }

    const finalizarTarefa = async (id, data) => {
        if (submit){
            return;
        }
        setSubmit(true)

        // adiona data e hora atual na descrição
        if (data.descricao.length > 250){
            toast.error('A descrição deve ter no mínimo 250 caracteres.')
            setSubmit(false)
            return
        }

        let now = new Date();
        let pad = (n) => n.toString().padStart(2, '0');
        let dataHora = `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${now.getFullYear()} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
        let descricao = `${data.descricao}\n Finalizado manualmente em ${dataHora} - Usuário ${user?.value?.name?.toUpperCase() || 'SEM NOME'}`;

        let dataJson = {
            saida: data.saida,
            descricao: descricao,
        }

        let result = await putService(`admin/tarefas/${id}/`, dataJson)
        if (result.type === 'success'){
            await _getTarefa()
            toast.success('Tarefa finalizada com sucesso!')
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        else if (result.data?.detail){
            toast.error(result.data?.detail)
        }        
        setSubmit(false)
    }
    return {
        
        tarefa: {value: tarefa, set:_getTarefa},

        pesquisa: {value: pesquisa, set:setPesquisa},
        semSaida: {value: semSaida, set:setSemSaida},
        dataInicial: { value: dataInicial, set: setDataInicial },
        dataFinal: { value: dataFinal, set: setDataFinal },        
        
        openDialog: {value: openDialog, set:setOpenDialog},
        deletar: {value: ()=>{console.log('não implementado')}, set: ()=>{console.log('não implementado')}},
        itemDelete:{value:templateDeletar, set:setTemplateDeletar},  
        pagination: {
            total: totalCount,
            page: page,
            setPage: setPage
        }, 
        submit: {value: submit, set: _getTarefa},
        openPermissaoDialog: {value: openPermissaoDialog, set: setOpenPermissaoDialog},
        finalizarTarefa: {value: submit, set: finalizarTarefa},
    }
}

export default useTarefaState
